interface LogoProps {
  /** Extra classes on the wrapper */
  className?: string;
  /** Tailwind height class for the symbol, e.g. "h-8" */
  markSize?: string;
  /** Tailwind size class for the wordmark, e.g. "text-lg" */
  wordClass?: string;
  /** Hide the "HKS" wordmark and show only the symbol */
  markOnly?: boolean;
}

/**
 * ENI HKS brand lockup — the official symbol (head + keystroke waveform)
 * plus the HKS wordmark. Single source of truth for the logo across the app.
 */
export default function Logo({
  className = '',
  markSize = 'h-8',
  wordClass = 'text-lg',
  markOnly = false,
}: LogoProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img src="/brand/hks-mark.png" alt="HKS" className={`${markSize} w-auto`} />
      {!markOnly && (
        <span className={`font-sans font-bold text-txt-primary tracking-tight ${wordClass}`}>
          <span
            className="text-transparent bg-clip-text"
            style={{ backgroundImage: 'linear-gradient(120deg, #7c5cfc, #4fc3f7)' }}
          >
            HKS
          </span>
          <sup className="text-[10px] text-txt-muted ml-0.5">™</sup>
        </span>
      )}
    </span>
  );
}
